import React from 'react';
import { Link } from 'react-router-dom';
import { FaArrowLeft, FaShieldAlt } from 'react-icons/fa';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div className="bg-white rounded-lg shadow-md p-6 mb-6">
          <Link
            to="/"
            className="inline-flex items-center text-green-600 hover:text-green-700 mb-4 transition-colors"
          >
            <FaArrowLeft className="mr-2" />
            Volver al Inicio
          </Link>
          <div className="flex items-center gap-3 mb-4">
            <FaShieldAlt className="text-green-600 text-4xl" />
            <h1 className="text-3xl sm:text-4xl font-playfair font-bold text-gray-900">
              Política de Privacidad
            </h1>
          </div>
          <p className="text-gray-600">
            Última actualización: {new Date().toLocaleDateString('es-PE', { year: 'numeric', month: 'long', day: 'numeric' })}
          </p>
        </div>

        {/* Content */}
        <div className="bg-white rounded-lg shadow-md p-6 sm:p-8 space-y-6">
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-3">1. Información que Recopilamos</h2>
            <p className="text-gray-700 mb-3">
              En Sumaq Mayu, recopilamos la siguiente información cuando utilizas nuestros servicios:
            </p>
            <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
              <li><strong>Datos personales:</strong> Nombre, DNI, correo electrónico, teléfono y ciudad de procedencia.</li>
              <li><strong>Datos de reserva:</strong> Fechas de entrada y salida, número de huéspedes, preferencias de habitación.</li>
              <li><strong>Cookies:</strong> Utilizamos cookies para mejorar tu experiencia de navegación y recordar tus preferencias.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-3">2. Uso de la Información</h2>
            <p className="text-gray-700 mb-3">
              Utilizamos tu información para:
            </p>
            <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
              <li>Procesar tus reservas y cotizaciones</li>
              <li>Comunicarnos contigo sobre tu estadía</li>
              <li>Mejorar nuestros servicios y experiencia del usuario</li>
              <li>Enviar información promocional (solo si lo autorizas)</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-3">3. Protección de Datos</h2>
            <p className="text-gray-700">
              Nos comprometemos a proteger tu información personal. Utilizamos medidas de seguridad 
              técnicas y organizativas para proteger tus datos contra accesos no autorizados, pérdida o alteración.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-3">4. Cookies</h2>
            <p className="text-gray-700 mb-3">
              Utilizamos cookies para:
            </p>
            <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
              <li>Recordar tus preferencias de navegación</li>
              <li>Mantener tu sesión de usuario activa</li>
              <li>Analizar el tráfico del sitio web</li>
              <li>Mejorar la funcionalidad del sitio</li>
            </ul>
            <p className="text-gray-700 mt-3">
              Puedes configurar tu navegador para rechazar cookies, pero esto puede afectar la funcionalidad del sitio.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-3">5. Compartir Información</h2>
            <p className="text-gray-700">
              No vendemos ni compartimos tu información personal con terceros, excepto cuando sea necesario 
              para procesar tu reserva o cuando lo requiera la ley.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-3">6. Tus Derechos</h2>
            <p className="text-gray-700 mb-3">
              Tienes derecho a:
            </p>
            <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
              <li>Acceder a tu información personal</li>
              <li>Solicitar la corrección de datos incorrectos</li>
              <li>Solicitar la eliminación de tus datos</li>
              <li>Oponerte al procesamiento de tus datos</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-3">7. Contacto</h2>
            <p className="text-gray-700">
              Si tienes preguntas sobre nuestra política de privacidad, puedes contactarnos en:
            </p>
            <div className="mt-3 p-4 bg-green-50 rounded-lg">
              <p className="text-gray-700">
                <strong>Email:</strong> sumaqmayu@gmail.com<br />
                <strong>WhatsApp:</strong> +51 947 791 970<br />
                <strong>Dirección:</strong> Tarapoto, San Martín, Perú
              </p>
            </div>
          </section>

          <section className="border-t pt-6">
            <p className="text-sm text-gray-600">
              Esta política de privacidad puede ser actualizada periódicamente. Te recomendamos revisarla 
              regularmente para estar informado sobre cómo protegemos tu información.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
